const schedulerDanish = {
  header: {
    title: "LinkedIn Planlægger",
    description: "Indstil hvilke dage og tidspunkter dine LinkedIn-opslag skal sendes."
  },
  limits: {
    scheduled: "Planlagte opslag: {count}",
    weekly: "Ugentlig grænse: {limit}",
    remaining: "Resterende: {count}"
  },
  limitWarning: {
    used: "Du har planlagt alle dine {limit} ugentlige opslag. Opgrader dit abonnement for at få flere.",
    upgrade: "Opgrader abonnement",
    low: "Du har {remaining} opslag tilbage til planlægning denne uge."
  },
  loading: "Indlæser dine indstillinger...",
  botDelivery: {
    title: "Bot Leveringsplan",
    description: "Indstil hvornår du vil modtage de ugentlige opslag fra botten",
    day: "Dag for leveringen:",
    time: "Tidspunkt:",
    info: "Den første besked kommer {day} kl. {time}. Efterfølgende beskeder kommer når du har accepteret et opslag."
  },
  postSchedule: {
    title: "LinkedIn Post-plan",
    description: "Vælg hvilke dage og tidspunkter dine LinkedIn-opslag skal publiceres",
    days: {
      monday: "Mandag",
      tuesday: "Tirsdag",
      wednesday: "Onsdag",
      thursday: "Torsdag",
      friday: "Fredag",
      saturday: "Lørdag",
      sunday: "Søndag"
    },
    addTime: "Tilføj tidspunkt",
    onePosts: "1 opslag",
    multiplePosts: "{count} opslag"
  },
  summary: {
    title: "Opsummering:",
    description: "Dine LinkedIn-opslag vil blive postet på følgende tidspunkter:",
    totalPosts: "Samlet antal planlagte opslag: {count} af {limit}"
  },
  timeModal: {
    title: "Vælg tidspunkt for {day}",
    label: "Vælg tidspunkt:",
    info: "Opslag på dette tidspunkt vil blive automatisk delt på LinkedIn.",
    cancel: "Annuller",
    add: "Tilføj tidspunkt"
  },
  save: {
    button: "Gem indstillinger",
    success: "Dine planlægningsindstillinger er gemt!",
    error: "Der opstod en fejl ved gem af dine indstillinger. Prøv igen senere."
  },
  timezone: {
    label: "Tidszone:",
    info: "Alle tidspunkter er angivet i tidszonen: {timezone}"
  },
  customerBanner: "Du redigerer planlægning for {customerName}"
};

export default schedulerDanish; 